import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';

import Form from '../../style-components/Form/Form.jsx';
import SelectAndSearch from '../../style-components/Form/SelectAndSearch.jsx';
import {
  useGetLearnunits,
  mergeLearnunits,
  getLearnunitErrorMessage,
} from '../../models/learnunits.js';

// La unidad recibida es la duplicada (se elimina); la seleccionada es la objetivo (se conserva).
const MergeLearnunit = ({ learnunit, setOpen }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [learnunitsData, learnunitsDataLoading] = useGetLearnunits();

  useEffect(() => {
    if (learnunitsData && !learnunitsDataLoading) {
      setOptions(
        (learnunitsData.data || [])
          .filter(unit => unit.id !== learnunit.id)
          .map(unit => ({ id: unit.id, label: unit.name || '' }))
          .sort((a, b) => a.label.localeCompare(b.label))
      );
    }
  }, [learnunitsData, learnunitsDataLoading]);

  const handleSubmit = async () => {
    if (!selected) {
      alert('Debe seleccionar la unidad de aprendizaje objetivo.');
      return;
    }
    const confirmation = window.confirm(
      `¿Estás seguro que quieres fusionar «${learnunit.name}» en «${selected.label}»? Esta acción no se puede deshacer.`
    );
    if (!confirmation) return;

    setLoading(true);
    const response = await mergeLearnunits(selected.id, learnunit.id);
    setLoading(false);
    if (response.status !== 200 && response.status !== 201) {
      alert(
        getLearnunitErrorMessage(
          response,
          'Error al fusionar las unidades de aprendizaje, intente de nuevo.'
        )
      );
      return;
    }
    alert('Unidades de aprendizaje fusionadas correctamente.');
    setOpen(false);
    window.location.reload();
  };

  return (
    <Form
      title='Fusionar unidad de aprendizaje'
      onSubmit={handleSubmit}
      onClose={() => setOpen(false)}
      loading={loading || learnunitsDataLoading}>
      <Typography>
        Todo el contenido de «{learnunit.name}» (cursos, preguntas, imágenes, etc.) pasará a la
        unidad seleccionada y «{learnunit.name}» será eliminada.
      </Typography>
      <SelectAndSearch
        name='target_learnunit'
        label='Unidad objetivo'
        value={selected}
        onChange={(_, value) => setSelected(value)}
        options={options}
        required
        fullWidth
      />
    </Form>
  );
};

export default MergeLearnunit;
